import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../shared/components/Button';
import OauthButton from '../../../../../shared/components/OauthButton/OauthButton';
import { useSelector } from 'react-redux';

const LOCALES_PATH = 'influencers.pages.campaign.apply_side_pane.facebook_connect.';

const InstagramError = React.memo(
  ({
    onRequestClose,
    nextStep,
    facebookIsOptional,
  }) => {
    const { t } = useTranslation();
    const testFlow = useSelector(state => state.config.test);

    return <div>
      <h3 className='mb-4'>
        {t(`${LOCALES_PATH}error`)}
      </h3>

      <div className="text-2 mb-3">
        {t(`${LOCALES_PATH}error_desc`)}
      </div>

      <hr className='my-6' />
      <Row className='justify-content-end'>
        <Col className="col-auto">
          <ButtonGroup className="non-adaptable">
            {facebookIsOptional
              ? <Button
                variant="secondary"
                type="button"
                onClick={nextStep}>
                {t('influencers.common.next')}
              </Button>
              : <Button
                variant="secondary"
                type="button"
                onClick={onRequestClose}>
                {t('influencers.common.cancel')}
              </Button>
            }
            {
              testFlow.some(flow => ['fb_required', 'fb_optional'].includes(flow))
                ? <Button
                  variant='primary'
                  onClick={() => {
                    const { origin, pathname } = window.location;
                    const queryParams = new URLSearchParams({
                      'facebook_oauth_callback': 'true',
                      'test_flow': testFlow.join(',').replace('fb_error', 'fb_success')
                    });
                    window.location.replace(`${origin}${pathname}?${queryParams.toString()}`);
                  }}>
                  {t(`${LOCALES_PATH}try_again`)}
                </Button>
                : <OauthButton
                  platform="facebook"
                  text={t(`${LOCALES_PATH}try_again`)}
                />
            }

          </ButtonGroup>
        </Col>
      </Row>
    </div>;
  }
);

InstagramError.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  facebookIsOptional: PropTypes.bool.isRequired,
};
export default InstagramError;